import React from 'react';
import { Dashboard } from '../../components/dashboard';

const Home = () => {
  return <Dashboard />;
};

export default Home;
